// Vendors
import $ from 'jquery';
import 'jquery.scrollto/jquery.scrollTo.min';

// Components
import carousels from '../framework/carousel';

// Config
const baseClassName = 'tabbed-media-carousel';
const CLASS_NAMES = {
  base: baseClassName,
  nav: `${baseClassName}__nav`,
  arrows: `${baseClassName}__arrows`,
  carousel: `${baseClassName}__carousel`,
};
let tabbedMediaCarousels = [];

$(`.${CLASS_NAMES.carousel}`).each((index, item) => {
  const carousel = $(item);
  const component = carousel.closest(`.${CLASS_NAMES.base}`);
  const nav = component.find(`.${CLASS_NAMES.nav}`);
  const navList = nav.find('ul');
  const customCarouselSettings = carousel.data();
  const carouselSettings = {
    speed: 500,
    arrows: false,
    autoplay: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  tabbedMediaCarousels[index] = carousels(`.${CLASS_NAMES.carousel}`, {
    ...carouselSettings,
    ...customCarouselSettings,
  });

  component.on(
    'click',
    `.${CLASS_NAMES.nav}__prev, .${CLASS_NAMES.arrows}__prev`,
    event => tabbedMediaCarousels[index].prev()
  );

  component.on(
    'click',
    `.${CLASS_NAMES.nav}__next, .${CLASS_NAMES.arrows}__next`,
    event => tabbedMediaCarousels[index].next()
  );

  component.on('click', `.${CLASS_NAMES.nav} [role="tab"]`, event => {
    const $tabs = nav.find('[role="tab"]');
    const $clickedTab = $(event.currentTarget);
    const slide = $tabs.index($clickedTab);
  
    tabbedMediaCarousels[index].goToSlide(slide);
  });
  
  tabbedMediaCarousels[index].on('afterChange', (event, slick, currentSlide) => {
    const $tabs = nav.find('[role="tab"]');
  
    $tabs.each((i, tab) => {
      const $tab = $(tab);
      const isActive = i === currentSlide;
  
      $tab
        .toggleClass('tabs__nav__item--active', isActive)
        .attr('aria-selected', isActive.toString())
        .attr('tabindex', isActive ? '0' : '-1');
    });
  
    nav.scrollTo('.tabs__nav__item--active', {
      duration: 150,
      axis: 'x',
    });
  
    component.find(`.${CLASS_NAMES.arrows}__current`).html(currentSlide + 1);
  });
  
});
